module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-UltraLight-816e4ead403eeba090d9a7c77c4ba9c2.otf";